import { render } from "./ball-chosen.vue?vue&type=template&id=90b3a44e&scoped=true"
import script from "./ball-chosen.vue?vue&type=script&lang=js"
export * from "./ball-chosen.vue?vue&type=script&lang=js"

import "@/assets/scss/common/ball/ball-chosen.scss?vue&type=style&index=0&id=90b3a44e&scoped=true&lang=scss"

import exportComponent from "/Users/thanhnguyen/Desktop/ThanhNguyen/projects/public_html/numbers-betting-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90b3a44e"]])

export default __exports__